import { CircleImage } from '@common/components/circle_images';

export const COURSES: CircleImage[] = [
  {
    name: '4月からスタート新プラン【火～木曜日の平日限定！3500円コース】★生ビール(1種)＋50種類ドリンク飲み放題(2時間)付き★前菜～お肉までお得に楽しめプラン♪',
    price: 3500,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczN7guPB1_vvF6oRRRUGSwgocys7gJOB5_DnJxkFPEIdA1BlQpNl6lMfykWE9PxvReMF_8RGMzX4-BNucG64GcKAro5ZpabIFc57GuaZfdEoornynr5aM9CejDiWbSvLFc9cc4fN_Ztbr5OINwuBBJ2d=w1567-h1045-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～28名様',
      '利用可能曜日: 火・水・木',
      '滞在可能時間: 2時間',
      '',
      '【コース内容】',
      '平日限定の気軽でお得にフリーラが楽しめる飲み放題付きのコースプラン☆',
      '2時間飲み放題で50種類以上のドリンクが楽しめます、ご友人や会社の同僚など気軽に集まる仲間とご利用ください。',
      '名物のフィッシュ＆チップスや低温調理をしたローストビーフが楽しめます。',
      '',
      '（注！）',
      '◆4月1日からご利用可能な新プランです',
      '◆こちらのプランは祝前日はご利用いただけません、ご了承ください。',
      '◆お席は2時間制になります。コース終了後は御退店の協力をお願いします。',
      '',
      '【お料理内容】',
      '・オードブル2種盛り合わせ',
      '・グリーンサラダ',
      '・名物フィッシュ＆チップス',
      '・ガーリックトースト',
      '・ローストビーフ',
      '',
      '◆2時間飲み放題◆',
      '・生ビール1種類(バドワイザー)',
      '・白/赤ワイン',
      '・カクテル/サワーなど50種類',
      '',
      '【注意事項】',
      '※お料理は仕入れ状況により内容の変更がある場合がございます',
      '※ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます',
      '※予約無し当日直接来店でのご利用は店舗の状況により利用できない場合があります',
      '◆ご予約確定後でも団体のお客様や貸し切り予約が入った場合にキャンセル対応をさせていただく場合があります',
      '※その場合はお一人様5000円分のフリーラお食事券をお送りしています、ご了承下さい',
    ],
  },
  {
    name: '4月からスタート新プラン【お気軽4000円コース】★生ビール(1種)＋50種類ドリンク飲み放題(2時間)付き★前菜～お肉～デザートまで気軽に楽しめるプラン♪',
    price: 4000,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczNc6cRkR9WM63rMCgZnzzls2jm9MbdVwJVJFL47j-_E5Rs-csymsRApj3JnGaUYG6eoy6g1p1K_vW8FjI9mABUd8wlXrwVOXXC5TjYSepog4Np_FL2pjW2XvRwunIhnN_RfWFdYSNgTT_Z4yufwhdxV=w1566-h1045-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～28名様',
      '利用可能曜日: 全曜日',
      '滞在可能時間: 2時間',
      '',
      '【コース内容】',
      'お気軽にフリーラの食事が楽しめる飲み放題付きのコースプラン☆',
      'オードブルからお肉・デザートまでしっかりお食事を満喫できます。',
      '2時間飲み放題で50種類以上のドリンクが楽しめます、会社の同僚や女子会など気軽に集まる仲間とご利用ください。',
      '名物のフィッシュ＆チップスや人気商品牛ハラミのステーキが楽しめます。',
      '',
      '（注！）',
      '◆4月1日からご利用可能な新プランです',
      '◆お席は2時間制になります。コース終了後は御退店の協力をお願いします。',
      '',
      '【お料理内容】',
      '・オードブル3種盛り合わせ',
      '・鶏と野菜のピリ辛マリネ',
      '・イタリアンサラダ',
      '・名物フィッシュ＆チップス',
      '・ガーリックトースト',
      '・牛ハラミのステーキ',
      '・本日のデザート',
      '',
      '◆2時間飲み放題◆',
      '・生ビール（バドワイザー）',
      '・白/赤ワイン',
      '・カクテル/サワーなど50種類',
      '',
      '※ドリンクはグラス交換制です',
      '',
      '【注意事項】',
      '※お料理は仕入れ状況により内容の変更がある場合がございます',
      '※ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます',
      '※予約無し当日直接来店でのご利用は店舗の状況により利用できない場合があります',
      '◆ご予約確定後でも団体のお客様や貸し切り予約が入った場合にキャンセル対応をさせていただく場合があります',
      '※その場合はお一人様5000円分のフリーラお食事券をお送りしています、ご了承下さい',
    ],
  },
  {
    name: '4月からスタート新プラン【料理満喫4500円コース】★生ビール(1種)＋50種類ドリンク飲み放題(2時間)付き★いろいろな料理が全11品楽しめるちょっと贅沢なプラン♪',
    price: 4500,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczPe93yQljIEWC3tCAVuOJ9LwwK0JCf0GVFcVPlzACBXjQtcB37nl3BvHfMh2xOiuHI5FIfMaTXpQ-PekZtT75CrO9iF3aPNclG4UN4fdcP7HrL0y3McogV1rFo5Wxm0nnAV1uUDMFq-8hjrA9DexPB4=w1566-h1045-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～28名様',
      '利用可能曜日: 全曜日',
      '滞在可能時間: 2時間',
      '',
      '【コース内容】',
      'フリーラの食事がふんだんに楽しめる飲み放題付きのコースプラン☆',
      'いろいろな料理を楽しみたい方におすすめのプランです！オードブルを中心にお肉が2種類と名物料理＆デザートまでしっかりお食事を満喫できます。',
      '2時間飲み放題で50種類以上のドリンクが楽しめます、会社の同僚や女子会などグルメな仲間と集まる時にご利用ください。',
      '名物のフィッシュ＆チップスやローストビーフ、人気商品牛ハラミのステーキが楽しめます。',
      '',
      '（注！）',
      '◆4月1日からご利用可能な新プランです',
      '◆お席は2時間制になります。コース終了後は御退店の協力をお願いします。',
      '',
      '【お料理内容】',
      '・オードブル3種盛り合わせ',
      '・イカと旬野菜のジェノヴェーゼ',
      '・鶏レバーのパテ',
      '・本日のサラダ～オニオンドレッシング～',
      '・低温調理のローストビーフ',
      '・名物フィッシュ＆チップス',
      '・ガーリックトースト',
      '・牛ハラミのステーキ',
      '・本日のデザート',
      '',
      '◆2時間飲み放題◆',
      '・生ビール（バドワイザー）',
      '・白/赤ワイン',
      '・カクテル/サワーなど50種類',
      '',
      '※ドリンクはグラス交換制です',
      '',
      '【注意事項】',
      '※お料理は仕入れ状況により内容の変更がある場合がございます',
      '※ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます',
      '※予約無し当日直接来店でのご利用は店舗の状況により利用できない場合があります',
      '◆ご予約確定後でも団体のお客様や貸し切り予約が入った場合にキャンセル対応をさせていただく場合があります',
      '※その場合はお一人様5000円分のフリーラお食事券をお送りしています、ご了承下さい',
    ],
  },
  {
    name: '【クラフト満喫プレミアムコース】★１番人気のコース内容★クラフトビール好きにも大好評♪クラフト生ビール全12種類＋50種類ドリンク飲み放題(3時間)付き＆名物料理や黒毛和牛ステーキなど全11品のお料理',
    price: 7000,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczOWHYnL73h2VHFjByuSmiX8zjCrCrD4DhrEO1cFPyaGvHDlJr-adHzlsHGt9H8fTMk8UEILtz2XAGvg38WSLUUIH5WDIZ_lYLm4u0jXErLOx64jmO68Sy4bEES29FgUxo5H2Cfoi6cjGIKFwy0WD9nj=w1536-h1536-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～28名様',
      '利用可能曜日: 全曜日',
      '滞在可能時間: 3時間',
      '',
      '【コース内容】',
      'フリーラの美味しい料理とクラフトビール含む全生ビール12種類をゆっくり堪能できるコースです！',
      'コース内容（全11品）＋3時間飲み放題(L.O30分前)',
      '◆フードメニュー【前菜盛り合わせ3種類・生ハムサラダ～バルサミコドレッシング～・フィッシュ＆チップス・ガーリックトースト・豪華お肉盛り合わせ５種類（A4黒毛和牛もも肉のステーキ・やみつきバッファローウィング・漬け込みハラミ肉のステーキ・極太生ソーセージのグリル・燻製ベーコンのソテー）】',
      '◆ドリンクメニュー【クラフトビール含む生ビール全12種類飲み放題】',
      'カクテル50種類＋グラス赤・白ワイン＋ソフトドリンク5種類【計60種類が飲み放題！】',
      '',
      '【お料理内容】',
      '◆前菜盛り合わせ３種類',
      '　　例）・コーンとチーズの冷製オムレツ',
      '　　　　・イカと旬野菜のジェノヴェーゼ',
      '　　　　・鶏レバーのパテ～バケットのせ～',
      '◆生ハムサラダ～バルサミコドレッシング～',
      '◆当店自慢のフィッシュ＆チップス',
      '◆ガーリックトースト',
      '◆豪華肉盛りプレート（お肉５種類盛り）',
      '（例）・A4ランク黒毛和牛もも肉のステーキ',
      '　　　・ピリ辛やみつきバッファローウィング',
      '　　　・漬け込み牛ハラミのステーキ',
      '　　　・極太生ソーセージ（リングイッサ）のグリル',
      '　　　・燻製ベーコンのソテー',
      '',
      '3時間飲み放題(L.O30分前)',
      'クラフトビール含む全12種類飲み放題',
      'カクテル50種類',
      'グラス赤・白ワイン',
      'ソフトドリンク5種類',
      '計60種類が飲み放題！',
      '',
      '【注意事項】',
      '※お料理は仕入れ状況により内容の変更がある場合がございます',
      '※ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます',
      '※予約無し当日直接来店でのご利用は店舗の状況により利用できない場合があります',
      '◆ご予約確定後でも団体のお客様や貸し切り予約が入った場合にキャンセル対応をさせていただく場合があります',
      '※その場合はお一人様5000円分のフリーラお食事券をお送りしています、ご了承下さい',
    ],
  },
  {
    name: '【クラフト満喫スタンダードコース】クラフトビール全12種類＋50種類ドリンク飲み放題(2.5時間)付き＆お料理全10品≪カジュアルに楽しむならコレ！≫デートにも◎2名様からOK！！',
    price: 6000,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczOmzJNE-PlY7hxwTz8rne9omGE1TMfiZLq3qW4VgQoo02pL4sSJ7Zd_CS5b7-wR2o0Zc1wU0UR0oyGnDo9DgsO0zNsHtmJqNvry043weoHG9CIBuVVHtwb72To9ASG1wvrMcxyjY07FPGZ4etVgcVWD=w1536-h1536-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～28名様',
      '利用可能曜日: 全曜日',
      '滞在可能時間: 2時間30分',
      '',
      '【コース内容】',
      'お食事は当店自慢の肉料理の4種盛りや大人気のフィッシュ＆チップスを含めた',
      'お料理全10品とクラフト生ビール全12種類の飲み放題2.5時間が楽しめます',
      'コース内容（全10品）＋2.5時間飲み放題(L.O30分前)',
      '◆フードメニュー【・前菜盛り合わせ3種類≪例）コーンとチーズの冷製オムレツ／鶏と旬野菜のピリ辛マリネ／鶏レバーのパテ≫・彩り野菜のコブサラダ・当店自慢フィッシュ＆チップス・ガーリックトースト・肉盛りプレート（贅沢お肉が４種類）】',
      '',
      '◆ドリンクメニュー【クラフトビール含む生ビール全12種類飲み放題】',
      'カクテル50種類＋グラス赤・白ワイン＋ソフトドリンク5種類【計60種類が飲み放題！】',
      '',
      '【お料理内容】',
      '・前菜盛り合わせ2種類',
      '・フレッシュ野菜のシーザーサラダ',
      '・名物フィッシュ&チップス',
      '・ガーリックトースト',
      '・お肉3種類の盛り合わせプレート',
      '    ・牛ハラミのステーキ',
      '    ・鳥取県産大山地鶏のバッファローウィング',
      '    ・ブラジル式極太生ソーセージのグリル',
      '',
      '◆2時間飲み放題付き(L.O30分前)◆',
      'クラフトビール含む全12種類飲み放題!',
      'カクテル50種類',
      'グラス赤・白ワイン',
      'ソフトドリンク5種類',
      '計60種類が飲み放題!',
      '',
      '【注意事項】',
      '※お料理は仕入れ状況により内容の変更がある場合がございます',
      '※ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます',
      '※予約無し当日直接来店でのご利用は店舗の状況により利用できない場合があります',
      '◆ご予約確定後でも団体のお客様や貸し切り予約が入った場合にキャンセル対応をさせていただく場合があります',
      '※その場合はお一人様5000円分のフリーラお食事券をお送りしています、ご了承下さい',
    ],
  },
  {
    name: '【クラフト満喫レギュラーコース】クラフトビール全12種類＋50種類ドリンク飲み放題(2時間)付き＆お料理全8品☆フリーラを気軽に楽しめるプラン♪飲み会利用歓迎☆直接来店OK☆',
    price: 5000,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczNA5KfbLN-1SBYZoaDLgE9A9HH0ILBYykq2Gev3IMq0qvnxarCm_RQjmMWXXMMC9oUeB0sJJXvcfBvTtO3SmyMCiPaVKQyGOV5HMqjQtV_yVzJQjqE9n-y0MXwTdxr_oTM0LqBYgV_OQF0ir9BKXVJR=w1280-h1280-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～28名様',
      '利用可能曜日: 全曜日',
      '滞在可能時間: 2時間',
      '',
      '【コース内容】',
      'お手軽に楽しめるフリーラのフード8品付きの飲み放題プランです！',
      '会社や友人との飲み会☆忘年会や新年会などで幅広くご利用ください',
      'コース内容（全８品）・2時間飲み放題付き(L.O30分前)',
      'クラフトビール含む全12種類飲み放題！＋カクテル50種類＋グラス赤・白ワイン＋ソフトドリンク5種類【計60種類が飲み放題！】',
      'お料理【・前菜盛り合わせ2種・フレッシュ野菜のシーザーサラダ・名物フィッシュ＆チップス・ガーリックトースト・お肉3種盛り合わせ（牛ハラミのステーキ／ピリ辛やみつきバッファローウィング／ブラジル式極太生ソーセージのグリル】',
      '',
      '【お料理内容】',
      '◆前菜盛り合わせ2種',
      '◆フレッシュ野菜のシーザーサラダ',
      '◆名物フィッシュ＆チップス',
      '◆ガーリックトースト',
      '◆お肉3種類の盛り合わせプレート',
      '　　・牛ハラミ肉のステーキ',
      '　　・バッファローウィング',
      '　　・ブラジル式極太生ソーセージのグリル',
      '',
      '◆2時間飲み放題付き(L.O30分前)',
      'クラフトビール含む全12種類飲み放題！',
      'カクテル50種類',
      'グラス赤・白ワイン',
      'ソフトドリンク5種類',
      '計60種類が飲み放題！',
      '',
      '【注意事項】',
      '※お料理は仕入れ状況により内容の変更がある場合がございます',
      '※ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます',
      '※予約無し当日直接来店でのご利用は店舗の状況により利用できない場合があります',
      '◆ご予約確定後でも団体のお客様や貸し切り予約が入った場合にキャンセル対応をさせていただく場合があります',
      '※その場合はお一人様5000円分のフリーラお食事券をお送りしています、ご了承下さい',
    ],
  },
  {
    name: '【日～木曜限定！8万円（税込）店舗貸切プラン】大人数でも少人数でも！完全貸切で生ビール付き飲み放題2時間＋料理が楽しめるプラン★プロジェクター＆マイク完備★【2時間制】',
    price: 80000,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczNpnZ5YZxb-W-lw3iJhy818WL5ahef7aCtKYTZ5hvLpRTPRZySB9QqUPs3NI-u6VF8QI6QoKXsy_mEdzv9bk9jVrO7CuOEIvI-dz9PebjlT2jYfzTrH5B_aheXrdh0-ULx84r4X5OMakuPCextZKZ4I=w1566-h1045-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～50名様',
      '利用可能曜日: 日・月・火・水・木',
      '滞在可能時間: 2時間',
      '',
      '【コース内容】',
      '【定額料金で完全貸切！】気の合う仲間でお店を貸し切って周りを気にせず、ワイワイ盛り上がりましょう♪人数は5人でも10名でも20名でも30名でも！！立食なら40名までは入ります★',
      '生ビールはアメリカのバドワイザー♪赤・白ワインやカクテル＆サワーなど50種類以上のドリンクが楽しめます。お料理は20名様がご満足いく量と内容になっています。',
      '【テーブル席28席／カウンター7席】【立食40名ほど】',
      '◇備品・マイク＆プロジェクター完備（お好きな音楽や、お客様が編集した映像なども流せます）簡易カラオケもあります',
      '◇電子タバコ喫煙ルーム完備',
      '★お電話にてお気軽にご相談ください（15時～23時対応）★',
      '',
      '【お料理内容】',
      '・オードブル2種盛り合わせ',
      '・本日のサラダ',
      '・自家製ピクルス',
      '・名物フィッシュ＆チップス',
      '・ガーリックトースト',
      '・バッファローウィング',
      '・牛ハラミのステーキ',
      '・本日のデザート',
      '',
      '◆2時間飲み放題付き',
      '・生ビール（バドワイザー）',
      '・白/赤ワイン',
      '・カクテル/サワーなど50種類',
      '',
      '※お料理は仕入れ状況により内容の変更がある場合がございます',
      '※ドリンクはグラス交換制です',
      '',
      '【注意事項】',
      '◆貸し切り予約のため開催日から1週間を過ぎたキャンセルは100％請求になります。',
      '◆こちらのプランは金・土・祝前日・祝日はご利用いただけません、ご了承ください。',
      '◆お席は2時間制になります。コース終了後は御退店の協力をお願いします。',
      '◆ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます。',
      '◆店舗を著しく汚したり備品などを破損した場合は請求させていただきます。',
    ],
  },
  {
    name: '【日～木曜限定！10万円（税込）店舗貸切プラン】大人数でも少人数でも！完全貸切でクラフトビール12種類付き飲み放題2時間＋しっかり料理が楽しめるプラン★プロジェクター＆マイク完備★【2時間制】',
    price: 100000,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczNpnZ5YZxb-W-lw3iJhy818WL5ahef7aCtKYTZ5hvLpRTPRZySB9QqUPs3NI-u6VF8QI6QoKXsy_mEdzv9bk9jVrO7CuOEIvI-dz9PebjlT2jYfzTrH5B_aheXrdh0-ULx84r4X5OMakuPCextZKZ4I=w1566-h1045-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～50名様',
      '利用可能曜日: 日・月・火・水・木',
      '滞在可能時間: 2時間',
      '',
      '【コース内容】',
      '【定額料金で完全貸切！】気の合う仲間でお店を貸し切って周りを気にせず、ワイワイ盛り上がりましょう♪人数は5人でも10名でも20名でも30名でも！！立食なら40名までは入ります★',
      'クラフトビールが全タップ12種類飲み放題♪赤・白ワインやカクテル＆サワーなど50種類以上のドリンクが楽しめます。お料理は20名様がご満足いく量と内容になっています。',
      '【テーブル席28席／カウンター7席】【立食40名ほど】',
      '◇備品・マイク＆プロジェクター完備（お好きな音楽や、お客様が編集した映像なども流せます）簡易カラオケもあります',
      '◇電子タバコ喫煙ルーム完備',
      '★お電話にてお気軽にご相談ください（15時～23時対応）★',
      '',
      '【お料理内容】',
      '・オードブル2種盛り合わせ',
      '・本日のサラダ',
      '・自家製ピクルス',
      '・名物フィッシュ＆チップス',
      '・ガーリックトースト',
      '・バッファローウィング',
      '・牛ハラミのステーキ',
      '・本日のデザート',
      '',
      '◆2時間飲み放題付き',
      '・クラフト生ビール12種類',
      '・白/赤ワイン',
      '・カクテル/サワーなど50種類',
      '',
      '※お料理は仕入れ状況により内容の変更がある場合がございます',
      '※ドリンクはグラス交換制です',
      '',
      '【注意事項】',
      '◆貸し切り予約のため開催日から1週間を過ぎたキャンセルは100％請求になります。',
      '◆こちらのプランは金・土・祝前日・祝日はご利用いただけません、ご了承ください。',
      '◆お席は2時間制になります。コース終了後は御退店の協力をお願いします。',
      '◆ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます。',
      '◆店舗を著しく汚したり備品などを破損した場合は請求させていただきます。',
    ],
  },
  {
    name: '【金・土・祝前日・祝日！12万円（税込）店舗貸切プラン】大人数でも少人数でも！完全貸切で生ビール付き飲み放題2時間＋料理が楽しめるプラン★プロジェクター＆マイク完備★【2時間制】',
    price: 120000,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczNpnZ5YZxb-W-lw3iJhy818WL5ahef7aCtKYTZ5hvLpRTPRZySB9QqUPs3NI-u6VF8QI6QoKXsy_mEdzv9bk9jVrO7CuOEIvI-dz9PebjlT2jYfzTrH5B_aheXrdh0-ULx84r4X5OMakuPCextZKZ4I=w1566-h1045-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～50名様',
      '利用可能曜日: 金・土・祝前日・祝日',
      '滞在可能時間: 2時間',
      '',
      '【コース内容】',
      '【定額料金で完全貸切！】気の合う仲間でお店を貸し切って周りを気にせず、ワイワイ盛り上がりましょう♪人数は5人でも10名でも20名でも30名でも！！立食なら40名までは入ります★',
      'クラフトビールが全タップ12種類飲み放題♪赤・白ワインやカクテル＆サワーなど50種類以上のドリンクが楽しめます。お料理は20名様がご満足いく量と内容になっています。',
      '【テーブル席28席／カウンター7席】【立食40名ほど】',
      '◇備品・マイク＆プロジェクター完備（お好きな音楽や、お客様が編集した映像なども流せます）簡易カラオケもあります',
      '◇電子タバコ喫煙ルーム完備',
      '★お電話にてお気軽にご相談ください（15時～23時対応）★',
      '',
      '【お料理内容】',
      '・オードブル2種盛り合わせ',
      '・本日のサラダ',
      '・自家製ピクルス',
      '・名物フィッシュ＆チップス',
      '・ガーリックトースト',
      '・バッファローウィング',
      '・牛ハラミのステーキ',
      '・本日のデザート',
      '',
      '◆2時間飲み放題◆',
      '・生ビール（バドワイザー）',
      '・白/赤ワイン',
      '・カクテル/サワーなど50種類',
      '',
      '※ドリンクはグラス交換制です',
      '',
      '【注意事項】',
      '◆お料理は仕入れ状況により内容の変更がある場合がございます',
      '◆貸し切り予約のため開催日から1週間を過ぎたキャンセルは100％請求になります。',
      '◆お席は2時間制になります。コース終了後は御退店の協力をお願いします。',
      '◆ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます。',
      '◆店舗を著しく汚したり備品などを破損した場合は請求させていただきます。',
    ],
  },
  {
    name: '【金・土・祝前日・祝日！15万円（税込）店舗貸切プラン】大人数でも少人数でも！完全貸切でクラフトビール12種類付き飲み放題2時間＋しっかり料理が楽しめるプラン★プロジェクター＆マイク完備★【2時間制】',
    price: 150000,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczNpnZ5YZxb-W-lw3iJhy818WL5ahef7aCtKYTZ5hvLpRTPRZySB9QqUPs3NI-u6VF8QI6QoKXsy_mEdzv9bk9jVrO7CuOEIvI-dz9PebjlT2jYfzTrH5B_aheXrdh0-ULx84r4X5OMakuPCextZKZ4I=w1566-h1045-s-no-gm?authuser=0',
    descriptions: [
      '利用可能人数: 2～50名様',
      '利用可能曜日: 金・土・祝前日・祝日',
      '滞在可能時間: 2時間',
      '',
      '【コース内容】',
      '【定額料金で完全貸切！】気の合う仲間でお店を貸し切って周りを気にせず、ワイワイ盛り上がりましょう♪人数は5人でも10名でも20名でも30名でも！！立食なら40名までは入ります★',
      'クラフトビールが全タップ12種類飲み放題♪赤・白ワインやカクテル＆サワーなど50種類以上のドリンクが楽しめます。お料理は20名様がご満足いく量と内容になっています。',
      '【テーブル席28席／カウンター7席】【立食40名ほど】',
      '◇備品・マイク＆プロジェクター完備（お好きな音楽や、お客様が編集した映像なども流せます）簡易カラオケもあります',
      '◇電子タバコ喫煙ルーム完備',
      '★お電話にてお気軽にご相談ください（15時～23時対応）★',
      '',
      '【お料理内容】',
      '・オードブル2種盛り合わせ',
      '・本日のサラダ',
      '・自家製ピクルス',
      '・名物フィッシュ＆チップス',
      '・ガーリックトースト',
      '・バッファローウィング',
      '・牛ハラミのステーキ',
      '・本日のデザート',
      '',
      '◆2時間飲み放題◆',
      '・クラフト生ビール12種類',
      '・白/赤ワイン',
      '・カクテル/サワーなど50種類',
      '',
      '※ドリンクはグラス交換制で',
      '',
      '【注意事項】',
      '◆お料理は仕入れ状況により内容の変更がある場合がございます',
      '◆貸し切り予約のため開催日から1週間を過ぎたキャンセルは100％請求になります。',
      '◆お席は2時間制になります。コース終了後は御退店の協力をお願いします。',
      '◆ラストオーダー時の飲み残しが多い場合は追加料金をいただく場合がございます。',
      '◆店舗を著しく汚したり備品などを破損した場合は請求させていただきます。',
    ],
  },
];
